import React from 'react';
import {makeStyles, Container, Typography, IconButton, Checkbox, Hidden, Tabs, Tab, AppBar} from '@material-ui/core';
import MUIDataTable from "mui-datatables";
import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import {MuiThemeProvider} from '@material-ui/core/styles';
import Approve from './component/Approve';
import CompLeaveApprove from '../CompLeaveReqsApproval/component/Approve';
import LeaveRecordCollection from '../Function/LeaveRecordCollection'
import CircularProgress from '@material-ui/core/CircularProgress';
import customAxios from "../../components/API/customAxios";
import {FormattedMessage, useIntl} from 'react-intl';
import TabPanel, {a11yProps} from "../UIComponent/TabPanel";
import ApprovalHistory from "./ApprovalHistory";
import {getApproves} from "./api/ApprovalAPI";
import {setLeaveApprovalColumns, setLeaveApprovalOptions} from "./TableSetting";
import {tableStyle, getMuiTheme, pxToRem} from "../UIComponent/CommonStyle"
import {isBrowser} from "react-device-detect";
import Grid from "@material-ui/core/Grid";
import ConfirmBox from '../UIComponent/ConfirmBox';
import CompLeaveReqsApproval from '../CompLeaveReqsApproval';
import { useParams, useLocation } from "react-router-dom";
import { checkIsNewCompLeave, setLocalStorageSettings } from '../Function/globalFunction';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { getCompLeaveApproves } from '../CompLeaveReqsApproval/api/ApprovalAPI';
import { useHistory } from 'react-router-dom';

let isApprove = '';

const useStyles = makeStyles((theme) => ({
    ...tableStyle(theme),
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
	'& .MuiBadge-badge': {
		padding: '0 4px',
		fontSize: '0.9rem',
		minWidth: '16px',
		height: '16px',
	},
}));

export default function LeaveApproval({routing, routingId, source}) {
    const location = useLocation();
    const classes = useStyles();
    const intl = useIntl();
    const history = useHistory();
    const [showCompetent, setShowCompetent] = React.useState(false);
    const [showStaffNo, setShowStaffNo] = React.useState(false);
    const [selectItem, setSelectItem] = React.useState([]);
    const [showSelectBox, setShowSelectBox] = React.useState('multiple');
    const [data, setData] = React.useState([]);
    const [showId, setShowId] = React.useState();
    const [selectedRowsData, setSelectedRowsData] = React.useState({
        selectedRows: '',
        displayData: '',
        isNewCompLeave: false,
    });
    const [tabValue, setTabValue] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [isHRAdminRole, setIsHRAdminRole] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [confirmOpen, setConfirmOpen] = React.useState(false);
    const [checked, setChecked] = React.useState(false);
    const [numberOfPendingLeaves, setNumberOfPendingLeaves] = React.useState();
    const [numberOfPendingOTs, setNumberOfPendingOTs] = React.useState();
    const [approvesLoaded, setApprovesLoaded] = React.useState(false);
    const [compLeavesLoaded, setCompLeavesLoaded] = React.useState(false);
    const isShiftDuty = localStorage.getItem('staff_duty') === window.global.shiftDuty;
    const isNewCompLeave = selectedRowsData.isNewCompLeave;

    const tab1Label = intl.formatMessage({ id: 'navigation.leave' });
    const tab2Label = intl.formatMessage({ id: 'navigation.ot_compensation' });

    React.useEffect(() => {
        async function getPermission() {
            let isHrAdminRole = JSON.parse(localStorage.getItem('isHrAdminRole'));

            if (isHrAdminRole === null) {
                const permissionResponse = await customAxios.get('/get_permission');
                isHrAdminRole = permissionResponse.data.hr_admin === true;
                localStorage.setItem('isHrAdminRole', isHrAdminRole);
            }

            if (isHrAdminRole) {
                setShowSelectBox('none');
                setShowStaffNo(true);
                setIsHRAdminRole(true);
            }
        }
        getPermission();
    }, []);
    
    React.useEffect(() => {
        async function fetchCompLeaveApproves() {
            try {
                const response = await getCompLeaveApproves(true);
                if (response.status === 200) {
                    setNumberOfPendingOTs(response.data.count);
                    setCompLeavesLoaded(true);
                }
            } catch (error) {
                console.error("Failed to fetch comp leave approval data:", error);
            }
        }
        fetchCompLeaveApproves();
    }, []);

    React.useEffect(() => {
        async function fetchLeaveApproves() {
            try {
                const response = await getApproves();
                if (response.status === 200) {
                    setData(LeaveRecordCollection(response.data, 'LeaveApproval', intl));
                    setNumberOfPendingLeaves(response.data.length);
                    setShowCompetent(true);
                    setApprovesLoaded(true);
                }
            } catch (error) {
                console.error("Failed to fetch leave approval data:", error);
                setShowCompetent(false);
            }
        }
        fetchLeaveApproves();
    }, []);

    React.useEffect(() => {
        if (routing !== '') {
            setShowId(routingId)
            setOpen(routing);
        }
    }, [routing, routingId]);

    React.useEffect(() => {
        setRowsPerPage(data.length);
        const params = new URLSearchParams(location.search);

        const tabIndex = params.get('tabIndex') ?? 0;
        setTabValue(Number(tabIndex));

        const processingApplicationId = params.get('processingApplicationId');
        if (processingApplicationId && data.length > 0) {
            const index = data.findIndex(row => row.id === processingApplicationId);

            if (index !== -1) {
                setSelectItem([index]);
            }
        }
    }, [location, data]);

    const handleOpen = (id, isNewCompLeave) => {
        setShowId(id);
        if (isNewCompLeave != undefined) {
            setSelectedRowsData({
                ...selectedRowsData,
                isNewCompLeave: isNewCompLeave
            });
        }
        setOpen(true);
    };
    const handleClose = () => {
        setLocalStorageSettings({
            'selectedIndex': 5,
            'isMyRequestOpen': 'false',
            'isApplicationOpen': 'false',
            'isLeaveApprovalOpen': 'true',
            'isHRAdminOpen': 'false'
        });
        history.push('/leave_approval?tabIndex=0');
        setOpen(false);
    };

    const handleConfirmOpen = async (selectIndex, selectData, action) => {
        if (action === 'approve') {
            const userHoursMap = {};
            const userNameMap = {};
            let isNewCompLeave = false;

            selectIndex.forEach((index) => {
                const row = selectData[index.index].data;
                isNewCompLeave = checkIsNewCompLeave(row[7]);

                if (isNewCompLeave) {
                    const userId = row[1];
                    const userName = row[2];
                    const hours = parseFloat(row[9].replace(' Hour(s)',''));
    
                    if (!userHoursMap[userId]) {
                        userHoursMap[userId] = 0;
                        userNameMap[userId] = userName;
                    }
                    userHoursMap[userId] += hours;
                }
            });

            if (userHoursMap) {
                const insufficientUsers = [];

                for (const userId in userHoursMap) {
                    const totalHours = userHoursMap[userId];
                    const userName = userNameMap[userId];
    
                    try {
                        const res = await customAxios.get(`/get_user_total_remaining?id=${userId}&idType=staffNo&filter=withoutCheckingExpiryDate`);
                        const remainingBalance = res.data.total_remaining;
    
                        if (totalHours > remainingBalance) {
                            insufficientUsers.push(userName);
                        }
                    } catch (error) {
                        console.error('Error fetching user remaining balance:', error);
                        return;
                    }
                }

                if (insufficientUsers.length > 0) {
                    alert(`${insufficientUsers.join(' & ')} ${intl.formatMessage({ id: 'error.user_no_enough_remaining_balance_CL' })}`);
                    return;
                }
            }
        }

        isApprove = action;
        setConfirmOpen(true);
        setSelectedRowsData({
            selectedRows: selectIndex,
            displayData: selectData
        })
    };
    const handleConfirmClose = () => {
        setConfirmOpen(false);
    };

    const handleChange = (event) => {
        setChecked(event.target.checked);
        if (event.target.checked === true) {
            setSelectItem([...Array(data.length).keys()])
        } else {
            setSelectItem([])
        }
    }

    let customBodyRender = (value, tableMeta, updateValue) => {
        return (
            <AssignmentIcon 
                onClick={(e) => {
                    e.stopPropagation();
                    const isNewCompLeave = checkIsNewCompLeave(tableMeta.rowData[7]);
                    handleOpen(tableMeta.rowData[0], isNewCompLeave);
                }}
                className={classes.muiDataTableIcon}
            />
        );
    }
    let customToolbar = () => {
        return (
            <Hidden mdUp>
                {/* { showSelectBox ? */}
                <IconButton style={{order: -1, height: pxToRem(45)}}>
                    <Checkbox
                        style={{color: '#FFF'}}
                        checked={checked}
                        onChange={handleChange}
                        inputProps={{'aria-label': 'primary checkbox'}}
                    />
                </IconButton>
                {/* : null */}
            </Hidden>
        );
    }
    let customToolbarSelect = (selectedRows, displayData, setSelectedRows) => (
        <React.Fragment>
            <div className={classes.customToolbarSelect}>
                <IconButton onClick={() => handleConfirmOpen(selectedRows.data, displayData, 'approve')}>
                    <CheckCircleIcon className={classes.deleteIcon} style={{color: '#FFF'}}/>
                    <Typography className={classes.customToolbarSelectText}
                                style={{color: '#FFF'}}>{intl.formatMessage({id: 'leave_approval.approval'})}</Typography>
                </IconButton>
                <IconButton onClick={() => handleConfirmOpen(selectedRows.data, displayData, 'reject')}>
                    <CancelIcon className={classes.deleteIcon} style={{color: '#FFF'}}/>
                    <Typography className={classes.customToolbarSelectText}
                                style={{color: '#FFF'}}>{intl.formatMessage({id: 'leave_approval.reject'})}</Typography>
                </IconButton>
                <Hidden mdUp>
                    <IconButton>
                        <Checkbox
                            style={{color: '#FFF'}}
                            checked={checked}
                            onChange={handleChange}
                            inputProps={{'aria-label': 'primary checkbox'}}
                        />
                    </IconButton>
                </Hidden>
            </div>
        </React.Fragment>
    );
    let columns = setLeaveApprovalColumns(customBodyRender, showStaffNo);
    const options = setLeaveApprovalOptions(selectItem, showSelectBox, customToolbar, handleOpen, customToolbarSelect, checkIsNewCompLeave, rowsPerPage);

    if (isBrowser === false) {
        columns = columns.filter(item => item.name !== 'approve')
    }

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (
        <main className={classes.content}>
            <div className={classes.appBarSpacer}/>
            <AppBar position="static" color="default">
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <Tab 
                        label={
                            <StyledBadge badgeContent={approvesLoaded && compLeavesLoaded ? numberOfPendingLeaves : 0} color="error">
                                <span style={{ padding: '0 10px' }}>
                                    {tab1Label}
                                </span>
                            </StyledBadge>
                        }
                        {...a11yProps(0)} 
                    />
                    <Tab 
                        label={
                            <StyledBadge badgeContent={approvesLoaded && compLeavesLoaded ? numberOfPendingOTs : 0} color="error">
                                <span style={{ padding: '0 10px' }}>
                                    {tab2Label}
                                </span>
                            </StyledBadge>
                        }
                        {...a11yProps(1)} 
                    />
                </Tabs>
            </AppBar>
            <TabPanel value={tabValue} index={0} disableGutters={true}>
                <Container maxWidth={false} className={classes.container}>
                    {showCompetent ?
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <Typography component="h1" variant="h5" align="left" style={{fontWeight: 600}}>
                                    <>
                                        {intl.formatMessage({ id: 'navigation.pending_approval' }) + ' - ' + intl.formatMessage({ id: 'navigation.leave' })}
                                    </>
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MUIDataTable
                                        title={intl.formatMessage({id: 'table.employee_list'})}
                                        data={data}
                                        columns={columns}
                                        options={options}
                                    />
                                </MuiThemeProvider>
                            </Grid>
                        </Grid>
                        :
                        <div className={classes.circularProgress}>
                            <CircularProgress/>
                        </div>
                    }
                </Container>
            </TabPanel>
            <TabPanel value={tabValue} index={1} disableGutters={true}>
                <CompLeaveReqsApproval 
                    routing={routing}
                    routingId={routingId}
                    isHRAdminRole={isHRAdminRole}
                    tabIndex={tabValue}
                    setNumberOfPendingOTs={setNumberOfPendingOTs}
                />
            </TabPanel>
            {open && (
                <Approve 
                    approveMode={window.global.singleApprove} 
                    handleClose={handleClose} 
                    open={open}
                    showId={showId}
                    isNewCompLeave={isNewCompLeave}
                    tabIndex={tabValue}
                    source={source}
                />
            )}
            {confirmOpen && (
                <ConfirmBox 
                    approveMode={window.global.multipleApprove}
                    leaveMode={window.global.LeaveApplication}
                    handleClose={handleConfirmClose}
                    open={confirmOpen}
                    selectedRows={selectedRowsData.selectedRows} 
                    displayData={selectedRowsData.displayData}
                    isApprove={isApprove}
                    tabIndex={tabValue}
                />
            )}
        </main>
    );
}